import './scroll-to-top-button.scss';

import React, { useState, useEffect, useRef } from 'react';

// Définition des types de propriétés du composant
interface ScrollToTopButtonProps {
  className?: string; // Classe CSS personnalisée pour le bouton
  threshold?: number; // Seuil à partir duquel le bouton apparaît partiellement
  iconSrc: string; // URL de l'icône du bouton
  onScrollTop?: () => void; // Fonction appelée lorsque l'utilisateur clique pour retourner en haut
  visibleThreshold?: number; // Seuil à partir duquel le bouton apparaît complètement
  scrollText?: string; // Texte du bouton "Scroll to Top"
  customStyles?: React.CSSProperties; // Styles CSS personnalisés
}


const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
  // Propriétés avec des valeurs par défaut du composant ScrollToTopButton
  className,
  threshold = 0,
  iconSrc = '',
  onScrollTop = () => { },
  visibleThreshold = 50,
  scrollText = '',
  customStyles = {},
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [partialVisible, setPartialVisible] = useState(false);

  const prevScrollYRef = useRef(window.scrollY);


  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const prevScrollY = prevScrollYRef.current;

    if (currentScrollY > threshold && prevScrollY > currentScrollY) {
      if (prevScrollY - currentScrollY > 17) {
        setIsVisible(true);
        setPartialVisible(false);
      }
    } else {
      setIsVisible(false);
    }

    if (currentScrollY > visibleThreshold && currentScrollY <= threshold && prevScrollY > currentScrollY) {
      setIsVisible(true);
      setPartialVisible(true);
    } else {
      setPartialVisible(false);
    }

    prevScrollYRef.current = currentScrollY;
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    onScrollTop();
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          className={`button-scroll-container ${className} ${partialVisible && 'partial-visible'}`}
          onClick={scrollToTop}
          style={{
            ...customStyles,
          }}
        >
          <img className='arrow-icon' src={iconSrc} alt="Go to top" />
          {scrollText &&
            <div className='scroll-button-text'>{scrollText}</div>
          }
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
